import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { ConsumerRewardHandlerProvider } from '../../providers/consumer-reward-handler';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

/**
 * Generated class for the ConsumerRewardSharePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-reward-share',
  templateUrl: 'consumer-reward-share.html',
})
export class ConsumerRewardSharePage {
	filePath: any;	
	loader: any;
	users: any;

  params: any = {
    page: 1,
    size: 25,
    term: '',
    cb: null
  }

  shareParams: any = {
    rewardId: null,
    toId: null,
    cb: null
  }

  isLoading: boolean = false;
  lastRequestReturnedValues: boolean = false;

  constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public alertCtrl: AlertController,
		public utils: Utils,
		public rewardProvider: ConsumerRewardHandlerProvider,
		public loadingCtrl: LoadingController,
		public globals: Globals) {

  	let reward = this.rewardProvider.selectedReward;

		this.filePath = this.globals.fileUrl;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerRewardSharePage');
  }

  getUsers(ev: any) {
    // Reset items back to all of the items
    this.resetUsers();
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      
      let params = {
        page: this.params.page,
        size: this.params.size,
        term: ev.target.value,

        cb: (users)=>{
          this.isLoading = false;

          this.lastRequestReturnedValues = (users.length==0) ? false : true;
          
          if(this.params.page == 1){
            this.users = users;  
          }else{
            for (var i = users.length - 1; i >= 0; i--) {
              this.users.push(users[i]);
            }          
          }
        }
      }

      this.rewardProvider.getUsers(params);

    }
  }

  resetUsers() {
    this.users = [];
  }

  confirmShare($e, user) {
    let alert = this.alertCtrl.create({
        title: 'Confirm Reward Transfer',
        message: 'Share reward with ' + user.FullName + '?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Confirm',
            handler: () => {              
                this.shareReward($e, user);
            }
          }
        ]
      });
      alert.present();
  }

  shareReward($e, user) {
    var control = $e

    user['wasPicked'] = true

    this.isLoading = true;

    let shareParams = {
        rewardId: this.rewardProvider.selectedReward.Id,
        toId: user.Id,

        cb: (result)=>{
          this.isLoading = false;
          delete user['wasPicked'];
          
          if(result.Success){
            let alert = this.alertCtrl.create({
              title: 'Success',
              subTitle: 'Reward has been shared!',
              buttons: [{
                text: 'Ok',
                handler: () => {
                    this.navCtrl.pop();
                  }
                }
              ]
            });

            alert.present();
          
          } else {
            let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: result.Message,
                buttons: [{
                  text: 'Ok',
                  handler: () => {
                      this.navCtrl.pop();
                    }
                  }
                ]
              });
              
              alert.present();
          }
        }
      }

      this.rewardProvider.transferReward(shareParams);
  }

  // doInfinite(infiniteScroll){
  //   if(!this.lastRequestReturnedValues){
  //     infiniteScroll.complete();
  //     return;
  //   } 

  //   this.params.page++;

  //   this.load(()=>{
  //     infiniteScroll.complete();
  //   });
  // }  


}



// WEBPACK FOOTER //
// ./src/pages/consumer-reward-share/consumer-reward-share.ts